import { HTTP, HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedMortalities: [],
    loadingMortalities: false
  },
  getters: {
    loadedMortalities (state) {
      return state.loadedMortalities
    },
    loadingMortalities (state) {
      return state.loadingMortalities
    }
  },
  mutations: {
    setLoadedMortalities (state, payload) {
      const retroCompatibleMortalityResult = payload.map(mortality => {
        return {
          ...mortality,
          date: new Date(mortality.date).toISOString().replace(/[:|.|-]/g, '-').substring(0, 10),
          batch: {
            ...mortality.batch,
            batch_number: mortality.batch.identifier
          }
        }
      })
      state.loadedMortalities = retroCompatibleMortalityResult
    },
    setLoadingMortalities (state, trueFalse) {
      state.loadingMortalities = trueFalse
    },
    createMortality (state, payload) {
      state.loadedMortalities.push(payload)
    },
    updateMortality (state, payload) {
      state.loadedMortalities = state.loadedMortalities.map(
        mortality => mortality.id === payload.id ? payload : mortality
      )
    },
    removeMortality (state, id) {
      state.loadedMortalities = state.loadedMortalities.filter(mortality => {
        return mortality.id !== id
      })
    },
    clearLoadedMortalities (state) {
      state.loadedMortalities = []
    }
  },
  actions: {
    loadMortalities ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadingMortalities', true)
      commit('setLoadedMortalities', [])

      return new Promise((resolve, reject) => {
        HTTP.get(
            payload ? `mortality.json/?search=${payload}` : 'mortality.json'
          )
          .then(result => {
            commit('setLoadedMortalities', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
            commit('setLoadingMortalities', false)
          })
      })
    },
    loadMortalitiesV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadingMortalities', true)
      commit('setLoadedMortalities', [])

      return new Promise((resolve, reject) => {
        HTTP_API_V2.get(
            payload ? `mortalities?batchId=${payload}` : 'mortalities'
          )
          .then(result => {
            commit('setLoadedMortalities', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
            commit('setLoadingMortalities', false)
          })
      })
    },
    createMortality ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const newMortality = {
        quantity: payload.quantity,
        age: payload.age,
        date: payload.date,
        batch: {
          id: payload.batch.id
        }
      }
      return new Promise((resolve, reject) => {
        HTTP.post('mortality.json/', newMortality)
          .then(result => {
            commit('createMortality', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createMortalityV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const newMortality = {
        quantity: payload.quantity,
        cullingQuantity: payload.cullingQuantity,
        naturalQuantity: payload.naturalQuantity,
        age: payload.age,
        date: payload.date,
        batch: {
          id: payload.batch.id
        }
      }
      return new Promise((resolve, reject) => {
        HTTP_API_V2.post('mortalities', newMortality)
          .then(result => {
            const retroCompatibleMortalityResult = {
              ...result.data,
              batch: {
                ...result.data.batch,
                batch_number: result.data.batch.identifier
              }
            }
            commit('createMortality', retroCompatibleMortalityResult)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateMortality ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const mortality = {
        quantity: payload.quantity,
        age: payload.age,
        date: payload.date,
        batch: {
          id: payload.batch.id
        }
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`mortality.json/${payload.id}/`, mortality)
          .then(result => {
            commit('updateMortality', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateMortalityV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const mortality = {
        quantity: payload.quantity,
        cullingQuantity: payload.cullingQuantity,
        naturalQuantity: payload.naturalQuantity,
        age: payload.age,
        date: payload.date,
        batch: {
          id: payload.batch.id
        }
      }
      return new Promise((resolve, reject) => {
        const {batch, ...mortalityWithoutBatch} = mortality
        HTTP_API_V2.put(`mortalities/${payload.id}`, mortalityWithoutBatch)
          .then(result => {
            const retroCompatibleMortalityResult = {
              ...result.data,
              batch: {
                ...result.data.batch,
                batch_number: result.data.batch.identifier
              }
            }
            commit('updateMortality', retroCompatibleMortalityResult)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeMortality ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`mortality.json/${payload}`)
          .then(result => {
            commit('removeMortality', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeMortalityV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP_API_V2.delete(`mortalities/${payload}`)
          .then(result => {
            commit('removeMortality', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedMortalities ({ commit }) {
      commit('clearLoadedMortalities')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mortality/index.js